import { API, graphqlOperation } from "aws-amplify";
import {
  createMonitorAttribute,
  deleteMonitorAttribute,
  updateMonitorAttribute,
} from "graphql/mutations";
import {
  CreateMonitorAttributeInput,
  DeleteMonitorAttributeInput,
  ListMonitorAttributeBySubjectIdQuery,
  ListSortMonitorAttributeBySeqNoQuery,
  MonitorAttribute,
  UpdateMonitorAttributeInput,
} from "types/graphqlapi";
import { GraphQLResult } from "@aws-amplify/api-graphql";
import {
  listMonitorAttributeBySubjectId,
  listSortMonitorAttributeBySeqNo,
} from "graphql/queries";

/**
 * 同一モニターのアトリビュートリストを取得
 * @param
 * @returns
 */
export const fetchMonitorAttributeByMonitorIdQuery = async (
  monitorId: string
) => {
  const result = (await API.graphql(
    graphqlOperation(listSortMonitorAttributeBySeqNo, {
      monitor_id: monitorId,
    })
  )) as {
    data: ListSortMonitorAttributeBySeqNoQuery;
  };

  const list = result.data?.listSortMonitorAttributeBySeqNo
    ?.items as MonitorAttribute[];

  list?.sort((a, b) => {
    if (a !== null && b !== null) {
      if (a.seq_no < b.seq_no) return -1;
      if (a.seq_no > b.seq_no) return 1;
      return 0;
    }
    return 0;
  });

  return list;
};

/**
 * 同一案件のアトリビュートリストを取得
 * @param
 * @returns
 */
export const fetchMonitorAttributeBySubjectIdQuery = async (
  subjectId: string
) => {
  const result = (await API.graphql(
    graphqlOperation(listMonitorAttributeBySubjectId, {
      subject_id: subjectId,
    })
  )) as {
    data: ListMonitorAttributeBySubjectIdQuery;
  };

  const list = result.data?.listMonitorAttributeBySubjectId
    ?.items as MonitorAttribute[];

  return list;
};

/**
 * 新規作成
 * @param
 * @returns 作成されたデータ
 */
export const createMonitorAttributeMutation = async (
  createMonitorAttributeInput: CreateMonitorAttributeInput
) => {
  const result = (await API.graphql(
    graphqlOperation(createMonitorAttribute, {
      input: createMonitorAttributeInput,
    })
  )) as GraphQLResult<{ createMonitorAttribute: MonitorAttribute }>;

  return result;
};

/**
 * 更新
 * @param
 * @returns 更新されたデータ
 */
export const updateMonitorAttributeMutation = async (
  updateMonitorAttributeInput: UpdateMonitorAttributeInput
) => {
  const result = (await API.graphql(
    graphqlOperation(updateMonitorAttribute, {
      input: updateMonitorAttributeInput,
    })
  )) as GraphQLResult<{ updateMonitorAttribute: MonitorAttribute }>;

  return result;
};

/**
 * 特定のデータ削除
 * @param
 * @returns 削除されたデータ
 */
export const deleteMonitorAttributeMutation = async (
  deleteMonitorAttributeInput: DeleteMonitorAttributeInput
) => {
  const result = (await API.graphql(
    graphqlOperation(deleteMonitorAttribute, {
      input: deleteMonitorAttributeInput,
    })
  )) as GraphQLResult<{ deleteMonitorAttribute: MonitorAttribute }>;

  return result;
};
